module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/images/bg-pattern-sparks.ec847266.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/images/bg-pattern-sparks.png
// module id = 3081
// module chunks = 11